import { Api } from "../config/request";

export default {
  GetOrderDetails(queryParams) {
    return Api.get(`/driver-accounting/order-payout-support?${queryParams}`);
  },
};
